import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Routes from './Routes';
import ErrorBoundary from './Components/ErrorBoundary';
const App = () => {
  return (
    
      <BrowserRouter>
        <ErrorBoundary>
          <Routes />
        </ErrorBoundary>
      </BrowserRouter>
  );
}

export default App;